<template>
  <tr>
    <td>{{ props.journey.vref }}</td>
    <td>{{ formatTime(props.journey.time) }}</td>
    <td>{{ props.journey.evtdata?.vmfields?.LineRef }}</td>
    <td>{{ props.journey.evtdata?.Description }}</td>
    <td>{{ props.journey.guid }}</td>
    <td><button @click="addJourney">Add</button></td>

  </tr>
</template>

<script setup>
import { defineProps, inject } from 'vue';

const dataStore = inject('datastore');

const props = defineProps({
  journey: {
    type: Object,
    required: true
  }
});

function formatTime(tm) {
  const date = new Date(tm * 1000);
  const formattedDate = date.toLocaleString();
  return formattedDate
}

function addJourney()
{
  console.log(`Addjourney ${props.journey}`)
  dataStore.addJourneyToWorking(props.journey)
}

</script>

<style scoped>
/* Add row-specific styles here if needed */
</style>